<template>
    <div class="main partner">
        <div class="head">
            <span style="margin-bottom:.3rem">云东农牧大数据平台</span>
            <div class="gobcak" @click="goBack"><img src="../../../assets/return.png" alt=""><span>返回上一层</span></div>
        </div>
        <div class="content">
            <div class="left">
                <div class="top">
                    <div class="server">
                        <div class="tag">
                            <img style="margin-left: 0.25rem;" src="../../../assets/yq/tag.png" alt="">
                            <span class="card_">运动量分布</span>
                        </div>
                        <div class="date">
                            <span @click="serviceStatusBtn(0)" :class="{ active: serviceStatus === 0 }">近7日</span>
                            <span @click="serviceStatusBtn(1)" :class="{ active: serviceStatus === 1 }">近15日</span>
                            <span @click="serviceStatusBtn(2)" :class="{ active: serviceStatus === 2 }">近30日</span>
                        </div>
                    </div>
                    <div class="sport">
                        <span>27656</span>
                        <span>平均运动量</span>
                    </div>
                    <div id="lineChart" class="line_chart"></div>
                </div>
                <div class="bottom">
                    <div class="server">
                        <div class="tag">
                            <img src="../../../assets/yq/tag.png" alt="">
                            <span class="card_">谱系概览</span>
                        </div>

                    </div>
                    <family :tagNo="tagNo||warnInfo.row[0]"></family>
                </div>
            </div>
            <div class="center">
                <div class="center_top">
                    <div class="top_item">
                        <span>耳标编码</span>
                        <div class="small_big">{{ tagNo||warnInfo.row[0] || 'A1000000003' }}
                            <div class="top_box"></div>
                        </div>
                    </div>
                    <div class="top_item">
                        <span>活畜品种</span>
                        <div class="small_big">敏盖绒山羊
                            <div class="top_box"></div>
                        </div>
                    </div>
                    <div class="top_item">
                        <span>月龄</span>
                        <div class="small_big">30
                            <div class="top_box"></div>
                        </div>
                    </div>
                    <div class="top_item">
                        <span>出生日期</span>
                        <div class="small_big">2020-10-12
                            <div class="top_box"></div>
                        </div>
                    </div>
                </div>
                <div class="center_box">
                    <div class="zhan"></div>
                    <div class="turn">
                        <div class="turn_item"></div>
                    </div>
                    <div class="animal sheep"></div>
                    <div style="left:.1rem;top:2.3rem" class="heart heart_1">
                        <div class="heart_r" style="margin-left:0">
                            <!-- <span>{{ info.todayStepNumber }}</span> -->
                            <span>72</span>
                            <span>当前心率</span>
                        </div>
                        <img src="../../../assets/sport.png" alt="">
                    </div>
                    <!-- <div style="left:2.58rem;top:0" class="heart">
                        <img src="../../../assets/heart.png" alt="">
                        <div class="heart_r">
                            <span>72</span>
                            <span>当前心率</span>
                        </div>
                    </div> -->
                    <div style="left:7.3rem;top:0.65rem" class="heart">
                        <img src="../../../assets/hot.png" alt="">
                        <div class="heart_r">
                            <!-- <span>{{ info.animalHeat == '—' ? '—' : info.animalHeat + "℃" }}</span> -->
                            <span>{{temperature|| warnInfo.row[2].split('当前体温')[1].split('度')[0] + '℃' }}</span>
                            <span>当前体温</span>
                        </div>
                    </div>
                    <div style="left:8.5rem;top:3.47rem" class="heart">
                        <img src="../../../assets/run.png" alt="">
                        <div class="heart_r">
                            <!-- <span class="heart_item">{{ info.liveness }}</span> -->
                            <span>活跃</span>
                            <span>活跃度</span>
                        </div>
                    </div>
                    <div style="left:.9rem;top:4.6rem" class="heart heart_">
                        <img src="../../../assets/sport.png" alt="">
                        <div class="heart_r" style="margin-left:0">
                            <!-- <span>{{ info.todayStepNumber }}</span> -->
                            <span>12932</span>
                            <span>今日运动量</span>
                        </div>
                    </div>
                    <!-- <div class="heart_line">
                        <div style="bottom:0;left:-0.12rem" class="big_box">
                            <div class="center_box1">
                                <div class="small_box"></div>
                            </div>
                        </div>
                    </div> -->
                    <div class="heart_line">
                        <div style="bottom:-0.12rem;left:1.4rem" class="big_box">
                            <div class="center_box1">
                                <div class="small_box"></div>
                            </div>
                        </div>
                    </div>
                    <div class="tempera">
                        <div style="bottom:-10px;left:-0.12rem" class="big_box">
                            <div class="center_box1">
                                <div class="small_box"></div>
                            </div>
                        </div>
                    </div>
                    <div class="rate">
                        <div style="bottom:-0.12rem;right:-0.1rem" class="big_box">
                            <div class="center_box1">
                                <div class="small_box"></div>
                            </div>
                        </div>
                    </div>
                    <div class="active_">
                        <div style="bottom:-0.12rem;left:-0.15rem" class="big_box">
                            <div class="center_box1">
                                <div class="small_box"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="footer">
                    <!-- <div v-for="(item,i) in 7" @click="switchStatusBtn(`${i}`)" class="switch" :class="{ active1: switchStatus === footerList[3] }">
                        <img :src="imgfile[i].img" alt="" v-if="imgfile[i].show">
                        <span>{{ footerList[i] }}</span>
                    </div> -->

                    <div @click="switchStatusBtn('0')" class="switch">
                        <img :src="imgfile[0].img" alt="" v-if="imgfile[0].show">
                        <span>{{ footerList[0] }}</span>
                    </div>
                    <div @click="switchStatusBtn('1')" class="switch">
                        <img :src="imgfile[1].img" alt="" v-if="imgfile[1].show">
                        <span>{{ footerList[1] }}</span>
                    </div>
                    <div @click="switchStatusBtn('2')" class="switch">
                        <img :src="imgfile[2].img" alt="" v-if="imgfile[2].show">
                        <span>{{ footerList[2] }}</span>
                    </div>
                    <div @click="switchStatusBtn('3')" :class="{ active1: switchStatus === footerList[3] }" class="switch">
                        <img :src="imgfile[3].img" alt="" v-if="imgfile[3].show">
                        <span>{{ footerList[3] }}</span>
                    </div>
                    <div @click="switchStatusBtn('4')" class="switch">
                        <img :src="imgfile[4].img" alt="" v-if="imgfile[4].show">
                        <span>{{ footerList[4] }}</span>
                    </div>
                    <div @click="switchStatusBtn('5')" class="switch">
                        <img :src="imgfile[5].img" alt="" v-if="imgfile[5].show">
                        <span>{{ footerList[5] }}</span>
                    </div>
                    <div @click="switchStatusBtn('6')" class="switch">
                        <img :src="imgfile[6].img" alt="" v-if="imgfile[6].show">
                        <span>{{ footerList[6] }}</span>
                    </div>
                </div>
            </div>
            <div class="right">
                <div class="top">
                    <div class="server">
                        <div class="tag">
                            <img style="margin-left: 0.25rem;" src="../../../assets/yq/tag.png" alt="">
                            <span class="card_">体温分布</span>
                        </div>
                        <div class="date">
                            <span @click="statusBtn(0)" :class="{ active: status === 0 }">近7日</span>
                            <span @click="statusBtn(1)" :class="{ active: status === 1 }">近15日</span>
                            <span @click="statusBtn(2)" :class="{ active: status === 2 }">近30日</span>
                        </div>
                    </div>
                    <div class="sport">
                        <span>38℃</span>
                        <span>平均体温</span>
                    </div>
                    <div id="lineChart1" class="line_chart1"></div>
                </div>
                <div class="bottom">
                    <div class="server">
                        <div class="tag">
                            <img style="margin-left: 0.25rem;" src="../../../assets/yq/tag.png" alt="">
                            <span class="card_">饮水量概览</span>
                        </div>
                        <div class="date">
                            <span @click="waterBtn(0)" :class="{ active: waterStatus === 0 }">近7日</span>
                            <span @click="waterBtn(1)" :class="{ active: waterStatus === 1 }">近15日</span>
                            <span @click="waterBtn(2)" :class="{ active: waterStatus === 2 }">近30日</span>
                        </div>
                    </div>
                    <div class="sport">
                        <span>2.2L</span>
                        <span>平均饮水量</span>
                    </div>
                    <div id="lineChart2" class="line_chart2"></div>
                </div>
            </div>
            <div v-if="isShow" class="box_">
                <div class="dialog" v-if="show1">
                    <span class="text">{{ text }}</span>
                    <span class="el-icon-close close_icon" @click="close"></span>
                    <div class="picture">
                        <div class="p_left">
                            <img :src='imgList[0]' v-if="show3" alt="">
                            <!-- <div class="img">
                                <img @click="imgBtn(1)" :src="imgList[1]" alt="">
                                <img @click="imgBtn(2)" :src='imgList[2]' alt="">
                                <img @click="imgBtn(3)" :src='imgList[3]' alt="">
                            </div> -->
                        </div>
                        <div class="p_right">
                            <div class="info_1">
                                <span v-for="(item, i) in infoList" :key="i">{{ item.name }}</span>
                            </div>
                            <div class="info_">
                                <span v-for="(item, i) in infoList" :key="i">{{
                                    item.value
                                }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="dialog_" v-if="show2">
                    <span class="text">{{ text }}</span>
                    <span class="el-icon-close close_icon" @click="closeIcon"></span>
                    <div class="table" style="margin-top: 1.2rem;">
                        <dv-scroll-board @mouseover="mouseover" :config="config" class="sheet"
                            style="width:14.9rem;min-height:3rem;padding-bottom:0.2rem;margin:auto;" />
                    </div>
                </div> -->
                <div class="dialog-box" v-if="show2">
                    <div class="dialog">
                        <div class="headers">
                            <span>{{ text }}</span>
                            <span class="el-icon-close" @click="close"></span>
                        </div>
                        <dv-scroll-board :config="config" @mouseover='mouseover'
                            style="width:100%;height:5rem;margin-top:0.1rem;padding: 0 .11rem;" />
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>
<script>
import Header from "../../../components/header.vue";
// import BMap from 'BMap'


import family from './components/family.vue'


export default {
    components: {
        Header, family
        // XChart
    },
    data() {
        return {
            infoList: [
                { name: '耳标编码：', value: '' },
                { name: '性别', value: '母' },
                { name: '绒直径：', value: '16.8um' },
                { name: '出生日期：', value: '2020-10-12' },
                { name: '月 龄：', value: 30 },
                { name: '绒产量：', value: 3.2 },
                { name: '出生重量：', value: 3.34 },
                { name: '断奶重量：', value: 15.2 },
                { name: '父亲编号：', value: '230304010080' },
                { name: '母亲编号：', value: '230304010090' },
            ],
            isShow: false,
            show1: false,
            show2: false,
            show3: true,
            numStatus: 'right',
            serviceStatus: 0,
            status: 0,
            waterStatus: 0,
            switchStatus: '活畜动态',
            footerList: ['基础信息', '绒质检测记录', '防疫记录', '活畜动态', '称重记录', '疾病治疗记录', '繁育记录'],
            imgfile: [{ img: require("../../../assets/file1.png"), show: true }, { img: require("../../../assets/file2.png"), show: true }, { img: require("../../../assets/file3.png"), show: true },
            { img: require("../../../assets/file4.png"), show: true }, { img: require("../../../assets/file5.png"), show: true }, { img: require("../../../assets/file6.png"), show: true }, { img: require("../../../assets/file7.png"), show: true }
            ],//左右不带下标的切换图
            imgfile_: [require("../../../assets/file11.png"), require("../../../assets/file22.png"), require("../../../assets/file33.png"),
            require("../../../assets/file44.png"), require("../../../assets/file55.png"), require("../../../assets/file66.png"), require("../../../assets/file77.png")
            ],//左右```带下标的切换图
            imgList: [require('../../../assets/yq/sheep3.jpg')],
            text: '基础信息',
            anType: '',
            path: [],
            config: {},
            exerciseDisMap: {},//存储运动量分布
            lineData: {
                0: [{ title: '单位：步', label: ['4-12', '4-13', '4-14', '4-15', '4-16', '4-17', '4-18'], value: [10008, 21234, 21678, 18907, 34567, 43567, 34567] }],
                1: [{ title: '单位：步', label: ['4-4', '4-5', '4-6', '4-7', '4-8', '4-9', '4-10', '4-11', '4-12', '4-13', '4-14', '4-15', '4-16', '4-17', '4-18'], value: [20008, 31234, 20678, 38907, 14567, 43567, 54567, 30008, 21234, 11678, 18000, 34500, 43500, 21347, 34564] }],
                2: [{ title: '单位：步', label: ['3-20', '3-21', '3-22', '3-23', '3-24', '3-25', '3-26', '3-27', '3-28', '3-29', '3-30', '3-31', '4-1', '4-2', '4-3', '4-4', '4-5', '4-6', '4-7', '4-8', '4-9', '4-10', '4-11', '4-12', '4-13', '4-14', '4-15', '4-16', '4-17', '4-18'], value: [20008, 31234, 20678, 38907, 14567, 43567, 54567, 30008, 21234, 11678, 18000, 34500, 43500, 21347, 34564, 21118, 21234, 40678, 35907, 14567, 43567, 54567, 30008, 21234, 19678, 28000, 34500, 43500, 21347, 34564] }],
            },
            lineData1: {
                0: [{ title: '单位：℃', label: ['4-12', '4-13', '4-14', '4-15', '4-16', '4-17', '4-18'], value: [38.6, 38.7, 39.0, 38.6, 38.9, 39.3, 39.1] }],
                1: [{ title: '单位：℃', label: ['4-4', '4-5', '4-6', '4-7', '4-8', '4-9', '4-10', '4-11', '4-12', '4-13', '4-14', '4-15', '4-16', '4-17', '4-18'], value: [38.3, 38.7, 39.0, 39.0, 38.5, 38.7, 38.8, 38.9, 39.1, 39.6, 38.7, 38.8, 38.6, 38.8, 39.2] }],
                2: [{ title: '单位：℃', label: ['3-20', '3-21', '3-22', '3-23', '3-24', '3-25', '3-26', '3-27', '3-28', '3-29', '3-30', '3-31', '4-1', '4-2', '4-3', '4-4', '4-5', '4-6', '4-7', '4-8', '4-9', '4-10', '4-11', '4-12', '4-13', '4-14', '4-15', '4-16', '4-17', '4-18'], value: [38.3, 38.7, 39.0, 39.0, 38.5, 38.7, 38.8, 38.9, 39.1, 39.6, 38.7, 38.8, 38.6, 38.8, 39.2, 38.3, 38.7, 39.0, 39.0, 38.5, 38.7, 38.8, 38.9, 39.1, 39.6, 38.7, 38.8, 38.6, 38.8, 39.2] }],
            },
            lineData2: {
                0: [{ title: '单位：L', label: ['4-12', '4-13', '4-14', '4-15', '4-16', '4-17', '4-18'], value: [2, 4, 3, 3, 4, 1, 5] }],
                1: [{ title: '单位：L', label: ['4-4', '4-5', '4-6', '4-7', '4-8', '4-9', '4-10', '4-11', '4-12', '4-13', '4-14', '4-15', '4-16', '4-17', '4-18'], value: [3, 5, 4, 1, 2, 3, 5, 4, 3, 3, 2, 3, 4, 4, 2] }],
                2: [{ title: '单位：L', label: ['3-20', '3-21', '3-22', '3-23', '3-24', '3-25', '3-26', '3-27', '3-28', '3-29', '3-30', '3-31', '4-1', '4-2', '4-3', '4-4', '4-5', '4-6', '4-7', '4-8', '4-9', '4-10', '4-11', '4-12', '4-13', '4-14', '4-15', '4-16', '4-17', '4-18'], value: [3, 5, 4, 1, 2, 3, 5, 4, 3, 3, 2, 3, 4, 4, 2, 3, 5, 4, 1, 2, 3, 5, 4, 3, 3, 2, 3, 4, 4, 2] }],
            },
            data_Sport: {},//存储运动
            temperatureDisMap: {},//体温
            temperaItem: {},//单个体温
            liveStockLocation: [],
            //  页码
            pageNum: 1,//第几页
            pageSize: 10,//一页几条
            total: 0,//总数
            hasPreviousPage: false,//上一页
            hasNextPage: false,//下一页
            // tableData: [],
            // 存储免疫记录数据
            immuneRecordData: [],
            // 存储治病记录数据
            diseaseRecordData: [],
            // 存储体重记录数据
            weightRecordData: [],
            // 存储繁育记录数据
            breedRecordData: [],
            // 存储防疫记录数据
            quarantineData: [],
            result: {},
            lang: [3, 20, 0, 0],
            shows: true,
            show4: true,
            show5: true,
            show6: true,
            warnInfo: {},
			tagNo:'',
			temperature:''
        };
    },
    watch: {},
    created() {
		console.log(this.$route.params.tagNo)
		this.tagNo=this.$route.params.tagNo
		this.temperature=this.$route.params.temperature
		console.log(this.tagNo,this.temperature)
        this.warnInfo = JSON.parse(window.localStorage.getItem('WARNINFO'))
        this.infoList[0].value = this.warnInfo.row[0] || '230304010008'
    },
    mounted() {
        this.setLineData(this.lineData[0], 'lineChart')
        this.setLineData(this.lineData1[0], 'lineChart1')
        this.setLineData(this.lineData2[0], 'lineChart2')
    },
    update() {

    },
    methods: {
        mouseover() {
            var divs = [...document.querySelectorAll('.dialog .row-item')]
            divs = [...divs]
            divs.forEach(item => {
                item.childNodes.forEach(it => {
                    (it.clientWidth < it.scrollWidth ? (it.title = it.innerText) : 'return')
                })
            })
        },
        // 弹出层关闭
        close() {
            this.isShow = false
            this.scrolling()
            this.switchStatus = '活畜动态'
            this.footerList = ['基础信息', '绒质检测记录', '防疫记录', '活畜动态', '称重记录', '疾病治疗记录', '繁育记录']
            this.isShow = false
            this.$nextTick(() => {
                this.imgfile = [{ img: require("../../../assets/file1.png"), show: true }, { img: require("../../../assets/file2.png"), show: true }, { img: require("../../../assets/file3.png"), show: true },
                { img: require("../../../assets/file4.png"), show: true }, { img: require("../../../assets/file5.png"), show: true }, { img: require("../../../assets/file6.png"), show: true }, { img: require("../../../assets/file7.png"), show: true }
                ]//左右不带下标的切换图
            })
        },
        // 返回上一层
        goBack() {
            this.$router.go(-1)
        },
        imgBtn(val) {
            this.show3 = false
            var img = this.imgList[0]
            this.imgList[0] = this.imgList[val]
            this.imgList[val] = img
            this.$nextTick(() => {
                this.show3 = true
            })
        },
        // 底部
        switchStatusBtn(val) {
            if (val === '3') {
                return
            }
            this.showList(val)
        },
        showList(val) {
            this.isShow = true
            this.NoScrolling()
            if (val === '0') {
                this.show1 = true
                this.show2 = false
                this.switchStatus = '基础信息'
                this.text = '基础信息'
            } else {
                this.show1 = false
                this.show2 = true
                // this.$nextTick(()=>{
                //     document.querySelector('.sheet').style.minHeight=6+'rem'

                // })
                if (val === '1') {
                    this.switchStatus = '绒质检测记录'
                    this.text = '绒质记录'
                    var dataArr = [[15.54, 1, 30, 1, 34, 45, '2020-03-16'],
                     [16.68, 2, 15, 2, 35, 74, '2021-04-23'],
                      [15.90, 1, 9, 1, 160, 5, '2022-03-06'], 
                      [16.32, 0.01, 15.3, 0.01, 214, 12, '2023-04-14']]
                    this.config = {
                        data: dataArr,
                        header: ['直径(um)', '直径标准差', '长度(mm)', '长度标准差', '长度变异系数(%)', '测量数', '测量日期'],
                        align: ['right', 'right', 'right', 'right', 'right', 'right', 'right'],
                        // columnWidth: [200, 300, 290, 200, 200, 260, 200, 200, 300],
                        headerHeight: 40,
                        rowNum: 6,
                        waitTime: 2000
                    }
                }
                if (val === '2') {
                    this.switchStatus = '防疫记录'
                    this.text = '防疫记录'
                    var dataArr = [
                        ['2023-03-21', '羊痘疫苗', '哈药集团生物疫苗有限公司', '20230201'],
                        ['2023-02-26', '三防四联', '哈药集团生物疫苗有限公司', '20230115'],
                        ['2022-10-05', '羊口蹄疫苗', '金宇保灵生物药品有限公司', '20220728'],
                        ['2022-09-18', '炭疽疫苗', '北京百欧博伟生物技术有限公司', '20220501'],
                    ]
                    this.config = {
                        data: dataArr,
                        header: ['防疫日期', '防疫项目', '疫苗厂家', '疫苗批次'],
                        align: ['left', 'left', 'left', 'left'],
                        columnWidth: [200, 200, 350, 200],
                        headerHeight: 40,
                        rowNum: 6,
                        waitTime: 2000
                    }

                }
                if (val === '4') {
                    this.switchStatus = '称重记录'
                    this.text = '称重记录'
                    var dataArr = [
                        ['2022-09-30', '42.8kg', '23.3kg', '19.5kg', ''],
                        ['2021-10-04', '23.3kg', '4.5kg', '18.8kg', ''],
                        ['2020-10-12', '4.5kg', '', '', ''],
                    ]
                    this.config = {
                        data: dataArr,
                        header: ['称重日期', '本次称重重量', '上次称重重量', '比上次增重', '称重人员'],
                        align: ['left', 'left', 'left', 'left', 'left'],
                        // columnWidth: [200, 200, 200, 150, 50, 200, 100],
                        headerHeight: 40,
                        rowNum: 6,
                        waitTime: 2000
                    }

                }
                if (val === '5') {
                    this.switchStatus = '疾病治疗记录'
                    this.text = '疾病记录'
                    var dataArr = [
                        ['2021-02-18', '肠胃炎', '食欲减退、腹泻、精神不振', '病羊口服0.5%痢菌净液50-100ml，每天2次灌服止泻克痢粉8-15g/次', '张青云', '症状缓解，可正常进食'],
                    ]
                    this.config = {
                        data: dataArr,
                        header: ['治病日期', '治病类型', '症状及并发症', '治疗方法', '兽医姓名', '治疗结果'],
                        align: ['left', 'left', 'left', 'left', 'left', 'left'],
                        columnWidth: [150, 150, 250, 300, 150, 300],
                        headerHeight: 40,
                        rowNum: 6,
                        waitTime: 2000
                    }
                }
                if (val === '6') {
                    this.switchStatus = '繁育记录'
                    this.text = '繁育记录'
                    var dataArr = [['2022-01-23', '李香国', 151, '2022-06-24', '正常', '自产', 1, 137, '',]]
                    this.config = {
                        data: dataArr,
                        header: ['配种日期', '配种员', '妊娠天数', '分娩日期', '分娩结果', '分娩方式', '产犊数量', '产犊间隔', '繁育说明'],
                        align: ['left', 'left', 'right', 'left', 'left', 'left', 'right', 'right', 'left'],
                        columnWidth: [200, 200, 200, 200, 200, 200, 200, 200, 200],
                        headerHeight: 40,
                        rowNum: 6,
                        waitTime: 2000
                    }
                }
            }
            var footerItem = this.footerList[3]
            this.footerList[3] = this.footerList[val]
            this.footerList[val] = footerItem
            this.imgfile[val].show = false
            this.imgfile[3].show = false
            this.$nextTick(() => {
                this.imgfile[val].img = this.imgfile_[3]
                this.imgfile[3].img = this.imgfile_[val]
                this.imgfile[val].show = true
                this.imgfile[3].show = true
            })
        },
        // 返回上一层
        goBack() {
            this.$router.go(-1)
        },
        // 运动量分布切换
        serviceStatusBtn(val) {
            this.serviceStatus = val
            this.setLineData(this.lineData[val], 'lineChart')
        },
        // 体温切换
        statusBtn(val) {
            this.status = val
            this.setLineData(this.lineData1[val], 'lineChart1')
        },
        // 饮水量概览
        waterBtn(val) {
            this.waterStatus = val
            this.setLineData(this.lineData2[val], 'lineChart2')
        },
        // 设置折线图
        setLineData(data, dom) {
            const colors = ['#1EE7E7', '#0EDAE2', '#5931FC'];
            const legend = [];
            const series = [];
            let xAxis = [];
            data.forEach((item, index) => {
                legend.push({
                    name: item.title,
                    textStyle: { color: '#FFFFFF' },
                    icon: 'circle',
                    itemWidth: 4,
                    itemhight: 4,
                })
                xAxis = item.label,
                    name = item.title,
                    series.push({
                        name: item.title,
                        type: "line",
                        showSymbol: false,
                        lineStyle: {
                            width: 2,
                        },
                        areaStyle: {
                            color: {
                                type: 'linear',
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [{
                                    offset: 0, color: 'rgba(0,246,236,0.48)' // 0% 处的颜色
                                }, {
                                    offset: 1, color: 'rgba(91,233,255,0)' // 100% 处的颜色
                                }],
                                global: false // 缺省为 false
                            }
                        },
                        color: colors[index],
                        data: item.value,
                    })
            })
            const line = {
                dom,
                xAxis,
                name,
                legend: {
                    data: legend,
                    // x: 'right',
                    // y: 'top',
                    top: "8%",
                    right: "3%",
                    itemWidth: 8,
                    itemHeight: 8,
                    padding: [10, 0, 0, 0],
                },
                series: series
            }
            this.lineChart(line)
        },
        lineChart(data) {
            this.chart = this.$echarts.init(document.getElementById(data.dom))
            // if (data.name === '体温') {
            //     this.lang = [3, 40, 0, 0]
            // } else {
            //     this.lang = [3, 50, 0, 0]
            // }
            // 隐藏动画加载效果。
            var option = {
                color: ['#106BDC', '#0EDAE2', '#5931FC'],
                tooltip: {
                    trigger: 'axis',
                    // formatter: function (params) {
                    //     return `
                    //     <p style="font-size: 14px; font-weight: normal;">${params[0].name
                    //         }</p><br/>
                    //      <p>
                    //     <p style="font-size: 14px; font-weight: normal;">${data.dom === 'lineChart' ? params[0].value + '步' : params[0].value + '℃'
                    //         }</p>
                    //      `;
                    // },
                    padding: [5, 20],
                    backgroundColor: 'rgba(255,255,255,0.8)',
                    borderColor: '#292929',
                    borderWidth: 1,
                    textStyle: {
                        color: '#050F37',
                    },
                },
                grid: {
                    // top: '20%',
                    left: '8%',
                    right: '4%',
                    bottom: '10%',
                    // height:'120px',
                    containLabel: true,
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: true,
                    axisLabel: {
                        color: '#FFFFFF',
                    },
                    axisLine: {
                        show: true, // X轴 网格线 颜色类型的修改
                        lineStyle: {
                            color: '#075F73',
                        },
                    },
                    axisTick: {
                        // X轴线 刻度线
                        show: true,
                        inside: true,
                        alignWithLabel: true
                    },
                    data: data.xAxis,
                },
                yAxis: {
                    name: data.name,
                    nameTextStyle: {
                        color: '#FFFFFF',
                        // padding: [3, 4],
                        padding: this.lang,
                        lineHeight: 60,
                        // verticalAlign:'bottom'
                        // align:'center'
                    },
                    // nameLocation:'end',
                    type: 'value',
                    splitNumber: 4,
                    axisLine: {
                        show: false, // Y轴线
                        lineStyle: {
                            color: 'rgba(85, 193, 255, 1)',
                        },
                    },
                    splitLine: {
                        lineStyle: {
                            type: 'dashed',
                            color: 'rgba(255,255,255,0.05)'
                        }
                    },
                    axisLabel: {
                        color: '#FFFFFF',
                    },
                },
                series: data.series,
            }
            this.chart.clear();
            this.chart.setOption(option)
            window.addEventListener('resize', () => {
                this.chart.resize()
            })
        },
    },
};
</script>
<style lang="scss" scoped>
.main {
    width: 24rem;
    // height: 13.5rem;
    min-height: 100vh;
    margin: 0 auto;
    background: url('../../../assets/yq/animal-bg.png');
    background-size: 100% 100%;

    .head {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 1.2rem;
        background: url('../../../assets/yq/headbg.png');
        background-size: 100% 100%;
        font-size: 0.55rem;
        font-family: AlibabaPuHuiTi-Bold, AlibabaPuHuiTi;
        font-weight: 700;
        color: #19ECFF;
        letter-spacing: 5px;

        .gobcak {
            position: absolute;
            bottom: 0;
            left: 0.25rem;
            font-size: .2rem;
            min-width: 2rem;
            font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
            font-weight: 400;
            color: #00E0DB;
            display: flex;
            align-items: center;
            cursor: pointer;

            img {
                width: .3rem;
                height: .3rem;
            }

            span {
                margin-left: .05rem;
            }
        }
    }


    .gobcak {
        width: .875rem;
        height: .4375rem;
        position: absolute;
        z-index: 99;
        bottom: -0.25rem;
        left: 0.25rem;
        font-size: .2rem;
        font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
        font-weight: 400;
        color: #00E0DB;
        display: flex;
        align-items: center;
        cursor: pointer;

        img {
            width: .3rem;
            height: .3rem;
        }

        span {
            margin-left: .05rem;
        }
    }


    .content {
        padding: .43rem 0.39rem;
        box-sizing: border-box;
        display: flex;
        // min-height: 12.5rem;
        // min-height: calc(100vh - 1rem);
        position: relative;

        .left {
            .top {
                width: 5.75rem;
                height: 5.63rem;
                background: url('../../../assets/yq/animal1.png');
                background-size: 100% 100%;

                .line_chart {
                    width: 100%;
                    // height: 4.5rem;
                    height: 3.7rem;
                    margin-top: .5rem;
                }
            }

            .bottom {
                width: 5.75rem;
                height: 5.5rem;
                margin-top: .39rem;
                background: url('../../../assets/yq/animal2.png');
                background-size: 100% 100%;
                display: flex;
                flex-direction: column;

            }
        }

        .center {
            flex: 1;
            // width: 8.85rem;
            // height: 8.61rem;
            height: 11.4rem;
            // margin: 0 1.08rem;
            // margin: 0 .55rem;
            position: relative;

            .center_top {
                width: 100%;
                display: flex;
                justify-content: center;

                .top_item {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    margin-left: .13rem;

                    span {
                        font-size: 0.18rem;
                        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                        font-weight: 400;
                        color: #FFFFFF;
                        padding-bottom: .08rem;
                    }

                    .small_big {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        width: 2.25rem;
                        height: 0.75rem;
                        background: rgba(0, 254, 255, 0.38);
                        opacity: 1;
                        font-size: 0.25rem;
                        font-family: Source Han Sans CN-Bold, Source Han Sans CN;
                        font-weight: bold;
                        color: #00E0DB;
                        position: relative;

                        &::after {
                            position: absolute;
                            left: 0;
                            top: 0;
                            content: "";
                            width: 0.13rem;
                            height: 0.13rem;
                            opacity: 1;
                            border-left: 0.01rem solid #00FEFF;
                            border-top: 0.01rem solid #00FEFF;
                        }

                        &::before {
                            position: absolute;
                            right: 0;
                            top: 0;
                            content: "";
                            width: 0.13rem;
                            height: 0.13rem;
                            opacity: 1;
                            border-top: 0.01rem solid #00FEFF;
                            border-right: 0.01rem solid #00FEFF;
                        }

                        .top_box {
                            position: absolute;
                            bottom: 0;
                            left: 0;
                            width: 100%;
                            height: .3rem;

                            &::after {
                                position: absolute;
                                left: 0;
                                bottom: 0;
                                content: "";
                                width: 0.13rem;
                                height: 0.13rem;
                                opacity: 1;
                                border-left: 0.01rem solid #00FEFF;
                                border-bottom: 0.01rem solid #00FEFF;
                            }

                            &::before {
                                position: absolute;
                                right: 0;
                                bottom: 0;
                                content: "";
                                width: 0.13rem;
                                height: 0.13rem;
                                opacity: 1;
                                border-bottom: 0.01rem solid #00FEFF;
                                border-right: 0.01rem solid #00FEFF;
                            }
                        }
                    }
                }
            }

            .center_box {
                width: 100%;
                height: 6.84rem;
                margin-top: 1rem;
                margin-left: .5rem;
                position: relative;

                .zhan {
                    height: 2.95rem;
                }

                .turn {
                    height: 3.84rem;

                    .turn_item {
                        width: 9rem;
                        height: 3.09rem;
                        margin: 1.16rem 1rem .34rem .7rem;
                        background: url('../../../assets/yq/turntable.png');
                        background-size: 100% 100%;
                    }
                }

                .heart_line {
                    position: absolute;
                    top: 2.7rem;
                    left: 1.8rem;
                    width: 1.5rem;
                    height: 0rem;
                    opacity: 1;
                    border: 0.01rem solid #00FEFF;

                    &::after {
                        position: absolute;
                        left: -0.065rem;
                        top: -0.065rem;
                        content: "";
                        width: 0.13rem;
                        height: 0.13rem;
                        background: #00FEFF;
                        ;
                        opacity: 1;
                        border-radius: 50%;
                    }

                }

                .tempera {
                    position: absolute;
                    top: .96rem;
                    left: 6rem;
                    // width: 1.1rem;
                    // height: 1.4rem;
                    opacity: 1;
                    border-left: 0.01rem solid #00FEFF;
                    border-top: 0.01rem solid #00FEFF;


                    &::after {
                        position: absolute;
                        right: -0.065rem;
                        top: -0.065rem;
                        content: "";
                        width: 0.13rem;
                        height: 0.13rem;
                        background: #00FEFF;
                        ;
                        opacity: 1;
                        border-radius: 50%;
                    }
                }

                .rate {
                    position: absolute;
                    top: 5rem;
                    left: 1.9rem;
                    width: 1.6rem;
                    height: 0rem;
                    opacity: 1;
                    border: 0.01rem solid #00FEFF;


                    &::after {
                        position: absolute;
                        left: -0.065rem;
                        top: -0.065rem;
                        content: "";
                        width: 0.13rem;
                        height: 0.13rem;
                        background: #00FEFF;
                        ;
                        opacity: 1;
                        border-radius: 50%;
                    }
                }

                .active_ {
                    position: absolute;
                    top: 3.8rem;
                    left: 6.5rem;
                    width: 1.8rem;
                    height: 0rem;
                    opacity: 1;
                    border: 0.01rem solid #00FEFF;

                    &::after {
                        position: absolute;
                        right: -0.065rem;
                        top: -0.065rem;
                        content: "";
                        width: 0.13rem;
                        height: 0.13rem;
                        background: #00FEFF;
                        ;
                        opacity: 1;
                        border-radius: 50%;
                    }
                }

                .animal {
                    width: 5.48rem;
                    height: 6rem;
                    position: absolute;
                    top: 0rem;
                    left: 1.7rem;
                    background: url('../../../assets/yq/sheep-bg.png');
                    background-size: 100% 100%;
                    background-position: .1rem .44rem;
                }

                .heart {
                    display: flex;
                    position: absolute;
                    height: 0.73rem;

                    img {
                        width: 0.78rem;
                    }

                    .heart_r {
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                        font-size: 0.45rem;
                        font-family: 汉仪菱心体简-regular, 汉仪菱心体简;
                        font-weight: 400;
                        color: #FFE11D;
                        margin-left: .1rem;

                        span:nth-child(2) {
                            font-size: 0.18rem;
                            font-family: Source Han Sans CN-Normal, Source Han Sans CN;
                            font-weight: 400;
                            color: #E1E3EF;
                        }

                        .heart_item {
                            font-family: Source Han Sans CN-Bold, Source Han Sans CN !important;
                        }
                    }




                }

                .heart_ {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-around;
                    height: 1.76rem;

                    .heart_r {
                        display: flex;
                        flex-direction: column;

                        span:nth-child(1) {
                            padding-top: .23rem;
                        }

                        span:nth-child(2) {
                            padding-top: .3rem;
                        }
                    }

                }

                .heart_1 {
                    display: flex;
                    justify-content: space-around;
                    // height: 1.76rem;

                    .heart_r {
                        display: flex;
                        flex-direction: column;

                        span:nth-child(1) {
                            padding-top: .1rem;
                        }

                        span:nth-child(2) {
                            padding-top: .3rem;
                        }
                    }

                }
            }
        }

        .right {
            .top {
                width: 5.75rem;
                height: 5.63rem;
                background: url('../../../assets/yq/animal1.png');
                background-size: 100% 100%;


                .line_chart1 {
                    width: 100%;
                    // height: 4.5rem;
                    height: 3.7rem;
                    margin-top: .5rem;
                }
            }

            .bottom {
                width: 5.75rem;
                height: 5.5rem;
                margin-top: .39rem;
                background: url('../../../assets/yq/animal2.png');
                background-size: 100% 100%;

                .line_chart2 {
                    width: 100%;
                    // height: 4.5rem;
                    height: 3.7rem;
                    margin-top: .5rem;
                }
            }
        }

        .footer {
            position: absolute;
            bottom: 0.5rem;
            left: .25rem;
            // left: -5.2rem;
            // width: 22.08rem;
            height: 2.8rem;
            display: flex;
            justify-content: center;

            .switch {
                font-size: 0.23rem;
                font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                font-weight: 400;
                color: #FFFFFF;
                display: flex;
                flex-direction: column;
                justify-content: inherit;
                align-items: center;
                margin-left: .5rem;
                cursor: pointer;
                // opacity: .7;
                opacity: 1;

                span {
                    padding-top: .25rem;
                }
            }

            .switch:nth-child(1) {
                margin-left: 0;
                // transform: translate(0, 1.2rem);
                margin-top: 2.3rem;
            }

            .switch:nth-child(2) {
                // transform: translate(0, 1.05rem);
                margin-top: 2.1rem;
            }

            .switch:nth-child(3) {
                // transform: translate(0, .95rem);
                margin-top: 1.9rem;

            }

            .switch:nth-child(4) {
                // transform: translate(0, .7rem);
                margin-top: 1.4rem;
            }

            .switch:nth-child(5) {
                // transform: translate(0, .95rem);
                margin-top: 1.9rem;

            }

            .switch:nth-child(6) {
                // transform: translate(0, 1.05rem);
                margin-top: 2.1rem;
            }

            .switch:nth-child(7) {
                // transform: translate(0, 1.2rem);
                margin-top: 2.3rem;


            }
        }
    }

    .video_box {
        position: relative;
        // width: 7.63rem;
        width: 5.75rem;
        height: 4rem;
        padding: .2rem;
        margin: .25rem;
        // border: 0.01rem solid rgba(0, 224, 219, 0.08);
        z-index: 100;

        .top_box {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 1rem;

            &::after {
                position: absolute;
                left: 0;
                bottom: 0;
                content: "";
                width: .18rem;
                height: .14rem;
                border-left: 1px solid #00E0DB;
                ;
                border-bottom: 1px solid #00E0DB;
                ;

            }

            &::before {
                position: absolute;
                right: 0;
                bottom: 0;
                content: "";
                width: .18rem;
                height: .14rem;
                border-right: 1px solid #00E0DB;
                ;
                border-bottom: 1px solid #00E0DB;
                ;

            }
        }
    }

    .server {
        width: 5.74rem;
        height: 0.44rem;
        background: rgba(25, 236, 255, 0.06);
        border-radius: 0.05rem 0.05rem 0rem 0rem;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .tag {
            display: flex;
            align-items: center;

            img {
                margin-left: .16rem;
            }
        }

        // padding-top: .24rem;
        .card_ {
            font-size: 0.23rem;
            font-family: Source Han Sans CN-Medium, Source Han Sans CN;
            font-weight: 500;
            color: #FFFFFF;
            padding-left: .25rem;
        }

        .date {
            // margin-left: 1.2rem;
            color: #7B8A89;
            padding-right: 0.15rem;

            span {
                padding: .03rem .05rem;
                border-radius: 0.03rem 0.03rem 0.03rem 0.03rem;
                font-size: 0.13rem;
                font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                background: rgba(255, 255, 255, 0.05);
                opacity: .5;
                font-weight: 400;
                cursor: pointer;
            }

            span:nth-child(2) {
                margin: 0 .13rem;
            }
        }
    }

    .active {
        background: rgba(255, 255, 255, 0.2) !important;
        // opacity: 1;
        color: #00E0DB !important;
        opacity: 1 !important;
    }

    .sport {
        display: flex;
        flex-direction: column;
        font-size: 0.38rem;
        font-family: Source Han Sans CN-Bold, Source Han Sans CN;
        font-weight: bold;
        color: #00E0DB;
        margin-top: .5rem;
        margin-left: .25rem;

        span:nth-child(2) {
            font-size: 0.15rem;
            font-family: Source Han Sans CN-Regular, Source Han Sans CN;
            font-weight: 400;
            color: #FFFFFF;
            margin-top: .2rem;
        }
    }

    @keyframes warn {
        0% {
            transform: scale(0);
            opacity: 0.0;
        }

        25% {
            transform: scale(0);
            opacity: 0.45;
        }

        50% {
            transform: scale(0.1);
            opacity: 0.65;
        }

        75% {
            transform: scale(0.5);
            opacity: 0.85;
        }

        100% {
            transform: scale(1);
            opacity: 0.0;
        }
    }

    .big_box {
        position: absolute;
        width: 0.24rem;
        height: 0.24rem;
        // background: rgba(0, 255, 255, 0);
        // opacity: 1;
        border: 0.1rem solid rgba(255, 255, 255, 1);
        border-radius: 50%;
        -webkit-border-radius: 50%;
        -moz-border-radius: 50%;
        z-index: 1;
        opacity: 0;
        -webkit-animation: warn 3s ease-out;
        -moz-animation: warn 3s ease-out;
        animation: warn 3s ease-out;
        -webkit-animation-iteration-count: infinite;
        -moz-animation-iteration-count: infinite;
        animation-iteration-count: infinite;

        .center_box1 {
            width: 0.16rem;
            height: 0.16rem;
            // background: rgba(0, 255, 255, 0);
            // opacity: 1;
            -webkit-border-radius: 50%;
            -moz-border-radius: 50%;
            z-index: 1;
            opacity: 0;
            -webkit-animation: warn 3s ease-out;
            -moz-animation: warn 3s ease-out;
            animation: warn 3s ease-out;
            -webkit-animation-iteration-count: infinite;
            -moz-animation-iteration-count: infinite;
            animation-iteration-count: infinite;
            border: 0.1rem solid rgba(255, 255, 255, 1);
            border-radius: 50%;
            margin: auto;
            margin-top: .025rem;

            .small_box {
                width: 0.06rem;
                height: 0.06rem;
                background: rgba(255, 255, 255, 1);
                opacity: 0;
                -webkit-animation: warn 3s ease-out;
                -moz-animation: warn 3s ease-out;
                animation: warn 3s ease-out;
                -webkit-animation-iteration-count: infinite;
                -moz-animation-iteration-count: infinite;
                animation-iteration-count: infinite;
                border-radius: 50%;
                padding: .03rem;
                margin: auto;
                margin-top: .03rem;
            }
        }
    }



    .active1 {
        color: #11F3D6 !important;
        opacity: 1 !important;
        z-index: 99999;
    }

    .box_ {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        position: fixed;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, .8);
        z-index: 9999;

    }

    .num_change {
        color: #FFFFFF !important;
    }

    .dialog_ {
        // margin-top: -2.5rem;
        min-width: 15.79rem;
        min-height: 3.77rem;
        position: relative;
        background: url('../../../assets/低.png');
        background-size: 100% 100%;

        .text {
            font-size: 0.3rem;
            font-family: Source Han Sans CN-Medium, Source Han Sans CN;
            font-weight: 500;
            color: #032929;
            position: absolute;
            top: 0.3rem;
            left: 7.2rem;
        }

        .close_icon {
            position: absolute;
            top: .25rem;
            right: .38rem;
            color: #00e0db;
            font-size: .3rem;
            cursor: pointer;
        }

        .num {
            font-size: 0.13rem;
            font-family: Source Han Sans CN-Regular, Source Han Sans CN;
            font-weight: 400;
            color: #FFFFFF;
            display: flex;
            justify-content: flex-end;
            margin: 0 .38rem 0.26rem 0;

            span {
                color: #7B8A8A;
                font-size: 0.18rem;
                font-weight: 700;
                margin-left: .21rem;
                cursor: pointer;
            }
        }

    }

    .dialog {
        // margin-top: -2.5rem;
        min-width: 12.79rem;
        min-height: 5.81rem;
        position: relative;
        background: url('../../../assets/info.png');
        background-size: 100% 100%;

        .text {
            font-size: 0.3rem;
            font-family: Source Han Sans CN-Medium, Source Han Sans CN;
            font-weight: 500;
            color: #032929;
            position: absolute;
            top: 0.25rem;
            left: 5.8rem;
        }

        .close_icon {
            position: absolute;
            top: .25rem;
            right: .38rem;
            color: #00e0db;
            font-size: .3rem;
            cursor: pointer;
        }

        .picture {
            display: flex;
            margin-top: 1.22rem;
            margin-left: 2rem;

            .p_left {
                width: 4.65rem;
                height: 4.1rem;
                display: flex;
                align-items: center;

                img {
                    width: 100%;
                    height: 3rem;
                    border-radius: 0.04rem 0.04rem 0.04rem 0.04rem;
                    cursor: pointer;

                }

                .img {
                    display: flex;
                    margin-top: .18rem;

                    img {
                        width: .88rem;
                        height: .88rem;
                        border-radius: 0.04rem 0.04rem 0.04rem 0.04rem;
                        cursor: pointer;

                    }

                    img:nth-child(2) {
                        margin: 0 .18rem;
                    }
                }
            }

            .p_right {
                flex: 1;
                height: 4.1rem;
                margin-left: .63rem;
                display: flex;
                // justify-content: space-around;

                .info_1 {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-around;
                    // align-items: center;
                    font-size: 0.2rem;
                    font-family: PingFang SC-中等, PingFang SC;
                    font-weight: normal;
                    color: #0DD3DD;
                }

                .info_ {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-around;
                    // align-items: center;
                    font-size: 0.2rem;
                    font-family: PingFang SC-中等, PingFang SC;
                    font-weight: normal;
                    color: #FFFFFF;
                    margin-left: .34rem;
                }

            }
        }

    }

    .dialog-box {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        position: fixed;
        top: 0;
        left: 0;
        background: transparent;
        opacity: 1;
        z-index: 99999999;

        .dialog {
            // position: fixed;
            // top: 50%;
            // left: 50%;
            // transform: translate(-5.625rem, -2.315rem);
            width: 11.25rem;
            height: 4.63rem;
            background: url('../../../assets/yq/warn/dialogbg.png');
            background-size: 100% 100%;

            .headers {
                display: flex;
                justify-content: space-between;
                align-items: center;
                width: 100%;
                height: 0.48rem;
                background: rgba(0, 174, 255, 0.6);
                border-radius: 0.05rem 0.05rem 0rem 0rem;
                padding-left: .25rem;
                padding-right: .11rem;

                span:nth-child(1) {
                    position: relative;
                    font-size: 0.23rem;
                    font-family: Source Han Sans CN-Medium, Source Han Sans CN;
                    font-weight: 500;
                    color: #00FEFF;

                    &::after {
                        content: '';
                        position: absolute;
                        left: 0.05rem;
                        bottom: -0.15rem;
                        width: 0.75rem;
                        height: 0.03rem;
                        background: #00FEFF;
                    }
                }

                span:nth-child(2) {
                    font-size: 0.28rem;
                    font-family: Source Han Sans CN-Medium, Source Han Sans CN;
                    font-weight: 500;
                    color: #FFFFFF;
                    cursor: pointer;
                }
            }
        }
    }

    .heart_line,
    .rate,
    .active_ {
        transform: scaleX(0);
        animation-delay: 1s;
        animation-duration: 1s;
        animation-direction: alternate;
        animation-name: FadeIn;
        animation-fill-mode: forwards;
    }

    .heart_1,
    .heart {
        transform: scaleX(0);
        animation-delay: 2s;
        animation-duration: 1s;
        animation-direction: alternate;
        animation-name: FadeIn1;
        animation-fill-mode: forwards;
    }

    .tempera
    {
    animation-delay: 1s;
    animation-duration: 1s;
    animation-direction: alternate;
    animation-name: FadeIn2;
    animation-fill-mode: forwards;
    }
}

@keyframes FadeIn {
    0% {
        transform: scaleX(0.3);
    }

    20% {
        transform: scaleX(0.6);
    }

    40% {
        transform: scaleX(0.9);
    }

    60% {
        transform: scaleX(1.1);
    }

    80% {
        transform: scaleX(0.9);
    }

    100% {
        transform: scaleX(1);
    }

}

@keyframes FadeIn1 {
    0% {
        transform: scaleX(1) translateY(-30px);
    }

    20% {
        transform: scaleX(1) translateY(0px);
    }

    40% {
        transform: scaleX(1) translateY(-20px);
    }

    60% {
        transform: scaleX(1) translateY(0px);
    }

    80% {
        transform: scaleX(1) translateY(-15px);
    }

    100% {
        transform: scaleX(1) translateY(0px);
    }

}

@keyframes FadeIn2 {
    0% {
        width: 0;
        height: 0.3rem;
    }

    20% {
        width: 0;
        height: 0.7rem;
    }

    40% {
        width: 0;
        height: 1.4rem;
    }

    60% {
        width: 0.6rem;
        height: 1.4rem;
    }

    80% {
        width: 1.3rem;
        height: 1.4rem;
    }

    100% {
        width: 1.1rem;
        height: 1.4rem;
    }

}


</style>

<style lang="scss">
.partner {

    .partner .dv-digital-flop canvas {
        text-align: left !important;
        width: 80% !important;
        height: 80% !important;
    }

    // .dv-digital-flop canvas {
    //     width: 80% !important;
    //     height: 80% !important;
    //     margin-left: .2rem !important;
    // }

    .active-ring-name {
        font-size: .23rem !important;
        padding-top: .1rem;
    }

    // .el-select > .el-input{
    //     width: auto;
    // }
    .el-input__inner {
        // width: 2.79rem;
        height: 0.38rem;
        background: rgba(0, 224, 219, 0.08) !important;
        border: 0.01rem solid rgba(25, 236, 255, 0.4);
        border-radius: 0.03rem;
        color: #FFFFFF !important;
        font-size: .13rem !important;
    }

    .el-input__icon {
        color: #00E0DB;
    }

    .el-select .el-input .el-select__caret {
        color: #00E0DB !important;
        line-height: inherit;

    }

    .search_input>.el-input__inner {
        // padding: 0 0 0 .4rem;
        width: 3.23rem !important;
    }

    .header {
        background: rgba(0, 174, 255, 0.3) !important;
        font-size: 0.18rem;
        font-family: Source Han Sans CN-Medium, Source Han Sans CN;
        font-weight: 500;
        color: #19ECFF;

    }

    // DataV
    .header-item {
        font-size: .175rem !important;
        opacity: .85;
    }

    .rows {
        // height: 3.5rem!important;
        padding: .05rem 0 .3rem 0;
    }

    .row-item {
        background: transparent !important;

        div:nth-child(7) {
            span {
                // margin-left: .6rem !important;
            }
        }
    }

    .row-item:hover {
        background-color: rgba(255, 255, 255, 0.05) !important;
    }

    .ceil {
        font-size: .15rem !important;
    }

    .ceil:first-child {
        // color: #FFC300;
    }

    // 排名轮播
    .dv-scroll-ranking-board .ranking-column {
        height: 0.15rem;
        background: #102c41;
        border: none;
        border-radius: 0.6rem 0.6rem 0.6rem 0.6rem !important;
        margin-top: 5px;
    }

    .dv-scroll-ranking-board .ranking-column .inside-column {
        width: 5.5rem;
        height: 0.15rem;
        background: linear-gradient(270deg, #FFE11D 0%, #00E0DB 100%) !important;
        border-radius: 0.6rem 0.6rem 0.6rem 0.6rem !important;
        margin-bottom: 0;
        overflow: hidden;
    }

    .dv-scroll-ranking-board .ranking-column .shine {
        background-color: transparent !important;
        animation: none !important;
    }

    .dv-scroll-ranking-board .ranking-info .rank {
        font-size: 0.18rem;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #FFFFFF;
    }

    .dv-scroll-ranking-board .ranking-info .info-name {
        font-size: 0.18rem;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #FFFFFF;
    }

    .ranking-value {
        font-size: 0.15rem;
        font-family: Source Han Sans CN-Medium, Source Han Sans CN;
        font-weight: 500;
        color: #FFE11D;
    }

    .dv-water-pond-level canvas {
        border: 1px solid #21EEE9;
        margin-left: .09rem;
        margin-top: .09rem;
    }

    .dv-water-pond-level text {
        font-size: 0.23rem !important;
        font-family: Source Han Sans CN-Medium, Source Han Sans CN !important;
        font-weight: 500 !important;
        color: #010E26 !important;
        opacity: 0 !important;

    }

}
</style>